import { isProduction } from "../constants.ts";

export const consoleLogStaging = (msg: unknown) => {
  if (isProduction) {
    return;
  }
  console.log(msg);
};
